const controlTypes = {};

controlTypes.ALIGNMENT = 'ALIGNMENT';
controlTypes.URL_INPUT = 'URL_INPUT';
controlTypes.ALT_TEXT_INPUT = 'ALT_TEXT_INPUT';
controlTypes.HOVER_BACKGROUND_COLOR = 'HOVER_BACKGROUND_COLOR';
controlTypes.HOVER_TEXT_COLOR = 'HOVER_TEXT_COLOR';
controlTypes.COLUMNS_COUNT_INPUT = 'COLUMNS_COUNT_INPUT';
controlTypes.FILE_URL_INPUT = 'FILE_URL_INPUT';
controlTypes.TEXT_COLOR = 'TEXT_COLOR';
controlTypes.TABLE_ROWS_AND_COLUMNS_COUNT_INPUT = 'TABLE_ROWS_AND_COLUMNS_COUNT_INPUT';
controlTypes.TABLE_ROWS_PADDING_INPUT = 'TABLE_ROWS_PADDING_INPUT';
controlTypes.FORM_BACKGROUND_INPUT = 'FORM_BACKGROUND_INPUT';
controlTypes.COLUMN_SPACING_INPUT = 'COLUMN_SPACING_INPUT';
controlTypes.TRANSITION_INPUT = 'TRANSITION_INPUT';
controlTypes.GALLERY_SETTINGS = 'GALLERY_SETTINGS';
controlTypes.CAROUSEL_SETTINGS = 'CAROUSEL_SETTINGS';
controlTypes.LAYOUT_SETTINGS = 'LAYOUT_SETTINGS';
controlTypes.LAYOUT_ITEM_SETTINGS = 'LAYOUT_ITEM_SETTINGS';

controlTypes.ICON_SETTINGS = 'ICON_SETTINGS';
controlTypes.SITE_NAV_SETTINGS = 'SITE_NAV_SETTINGS';

export default controlTypes;